var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.001,
    viewBox: "0 0 16 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26313",
    "data-name": "Path 26313",
    d: "M14.809,13.635l-1.179,1.179,6.821,6.821-6.821,6.821,1.179,1.179,6.821-6.821,6.822,6.822,1.179-1.179-6.822-6.822,6.822-6.822-1.179-1.179L21.63,20.456Z",
    transform: "translate(-13.631 -13.634)",
    fill: "#e10092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePink);
export default __webpack_public_path__ + "static/media/close-pink.9ee19d0fa11565b6dc1f904cda678e06.svg";
export { ForwardRef as ReactComponent };